import { lazy } from 'react';

const IndicatorUpdaterModal = lazy(() => import('./modals/IndicatorModal'));
const ShareToGoogleClassroom = lazy(() =>
  import('./components/ActionItems/ShareToGoogleClassroomModal'),
);
const AnsweredStudents = lazy(() => import('./modals/AnsweredStudentsDrawer'));

export default {
  INDICATOR_UPDATER_MODAL: IndicatorUpdaterModal,
  SHARE_TO_GOOGLE_CLASSROOM: ShareToGoogleClassroom,
  ANSWERED_STUDENTS: AnsweredStudents,
};
